module.exports = __webpack_public_path__ + "assets/img/title-636d34e9.png";